// extracted by mini-css-extract-plugin
module.exports = {"containerOverrides":"GiftSubscription_containerOverrides__qXh8I","box":"GiftSubscription_box__cBnE9"};